module.exports = __webpack_public_path__ + "media/images/plus-sign-68cfe87ad3fbfc288fd8070f4f11e914.svg";